import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import S3Upload      from 's3_upload';
import QRCode        from 'react-qr-code';
import ContentsTab   from 'contents_tab';

//import Grid          from '@common/grid/_grid';

import ContentsModal from '@partials/contents-modal';
import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------


class ReportEdit extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let event = this.props.data.event; 
    event.editReportModal = this.showModal.bind(this);
    this.props.data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      tab: 'base',
      modal: false,
      reports: [],
      update: [],
      update_cell: [],
      update_etc: [],
      update_etc_cell: [],
      is_update: false,
      emphasis_columns: [],
      now_contents_id: null,
      preview: {},
      is_reduction: false,
      show_followers_count: false,
      initialFocusLocation: undefined,
      initialFocusLocationEtc: undefined,
    };
  }
  // -------------------------------------------------------
  
  showModal(contents_id) {
    Utils.request.bind(this)('/api/project/workflow/get_report_insights', { project_id: this.props.data.project.id },
      function(res){
        if( this.props.target_shortcode != undefined ){
          let reports = res.body.reports.filter((d) => { if( this.props.target_shortcode.indexOf(d.shortcode) >= 0 ) return d; });
          let reports_etc = res.body.reports_etc;
          this.setState({ modal: true, update_cell: [], update_etc_cell: [], reports: reports, reports_etc: reports_etc });
        } else {
          this.setState({ modal: true, update_cell: [], update_etc_cell: [], reports: res.body.reports, reports_etc: res.body.reports_etc });
        }
        
        // 初期フォーカスイベント
        try {
          res.body.reports.map((r, key) => {
            if( r.contents_id == contents_id ) this.setState({ initialFocusLocation: { columnId: 'insta_id', rowId: String(key + 3) } });
          });
          res.body.reports_etc.map((r, key) => {
            if( r.contents_id == contents_id ) this.setState({ tab: 'etc', initialFocusLocationEtc: { columnId: 'insta_id', rowId: String(key + 3) } });
          });
        } catch(e) {}
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  updateReports(reports, reports_etc) {
    let preview = this.state.preview;
    reports.map((d) => { if( d.shortcode == preview.shortcode ) preview = Object.assign(preview, d); });
    reports_etc.map((d) => { if( d.contents_id == preview.contents_id ) preview = Object.assign(preview, d); });
    
    this.setState({ reports: reports, reports_etc: reports_etc, preview: preview });
  }
  // -------------------------------------------------------
  
  closeModal() {
    if( this.state.is_update == true ){
      let chk = confirm('編集中の内容を破棄して画面を閉じてもよろしいですか？');
      if( chk == false ) return;
    }
    
    this.setState({ modal: false, targets: [], is_update: false, preview: {}, update_cell: [], update_etc_cell: [] });
  }
  // -------------------------------------------------------
  
  updateEvent(rows, columns) {
    
    // フィード・リール
    if( this.state.tab == 'base' ){
      
      // 変更点のセルをピックアップ
      let update_cell = [];
      try {
        rows.map((d) => {
          this.state.reports.map((r) => {
            if( r.shortcode != d.shortcode ) return;
            
            for( let id in d ){
              if( d[id] != undefined && d[id] != null ){
                let temp = String(d[id]).replace(/,|%/ig, '');
                if( r[id] !== undefined && String(r[id]) != temp ) update_cell.push({ rowId: d.rowId, column: id });
              }
            }
          });
        });
      } catch(e) {}
      
      this.setState({ update: rows, update_cell: update_cell, is_update: true });
      
    }
    
    // フィード・リール
    if( this.state.tab == 'etc' ){
      
      // 変更点のセルをピックアップ
      let update_cell = [];
      try {
        rows.map((d) => {
          this.state.reports_etc.map((r) => {
            if( r.shortcode != d.shortcode ) return;
            
            for( let id in d ){
              if( d[id] != undefined && d[id] != null ){
                let temp = String(d[id]).replace(/,|%/ig, '');
                if( r[id] !== undefined && String(r[id]) != temp ) update_cell.push({ rowId: d.rowId, column: id });
              }
            }
          });
        });
      } catch(e) {}
      
      this.setState({ update_etc: rows, update_etc_cell: update_cell, is_update: true });
      
    }
  }
  // -------------------------------------------------------
  
  saveEvent() {
    let chk = confirm('レポートのデータを変更します。よろしいですか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/workflow/save_report_insights', { project_id: this.props.data.project.id, mode: 'update', update: this.state.update, update_etc: this.state.update_etc },
      function(res){
        alert('レポートデータを更新しました！');
        this.setState({ modal: false, targets: [], is_update: false, preview: {} });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  deleteInishgt(insight_id) {
    let chk = confirm('インサイトを削除します。よろしいですか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/workflow/delete_report_insights', { project_id: this.props.data.project.id, insight_id: insight_id },
      function(res){
        alert('インサイトを削除しました！');
        this.updateReports.bind(this)(res.body.reports, res.body.reports_etc);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  focus(rows) {
    this.state.reports.map((d) => {
      if( d.shortcode == rows.shortcode ){
        this.setState({ preview: Object.assign({ insta_id: rows.insta_id }, d) });
      }
    });
    this.state.reports_etc.map((d) => {
      if( d.contents_id == rows.shortcode ){
        this.setState({ preview: Object.assign({ insta_id: rows.insta_id }, d) });
      }
    });
  }
  // -------------------------------------------------------
  
  changeTab(tab) {
    this.setState({ tab: tab });
  }
  // -------------------------------------------------------
  
  setFollowersCount() {
    this.setState({ show_followers_count: (this.state.show_followers_count == true) ? false : true });
  }
  // -------------------------------------------------------
  
  actionReduction() {
    this.setState({ is_reduction: (this.state.is_reduction == true) ? false: true });
  }
  // -------------------------------------------------------
  
  render() {
    let base = this.props.data;
    let detail = base.project.detail;
    
    let preview = this.state.preview;
    let is_preview = (Object.keys(this.state.preview).length > 0);
    
    let width = (this.state.is_reduction) ? 'calc(100% - 90px)' : 'calc(100% - 400px)';
    let left = '10px'; //(is_preview) ? '10px' : null;
    
    let is_reduction = (this.state.is_reduction == true) ? 'is_reduction' : '';
    
    // レポートタブ
    let tabs = [
      { id: 'base',  name: 'フィード・リール',      html: <ReportScoreSettingGrid mode="base" reports={this.state.reports} focus_ev={this.focus.bind(this)} update={this.state.update} update_cell={this.state.update_cell} update_ev={this.updateEvent.bind(this)} save_ev={this.saveEvent.bind(this)} close_ev={this.closeModal.bind(this)} initialFocusLocation={this.state.initialFocusLocation} /> },
      { id: 'etc',   name: 'ストーリー・TIKTOK・X', html: <ReportScoreSettingGrid mode="etc"  reports={this.state.reports_etc} focus_ev={this.focus.bind(this)} update={this.state.update_etc} update_cell={this.state.update_etc_cell} update_ev={this.updateEvent.bind(this)} save_ev={this.saveEvent.bind(this)} close_ev={this.closeModal.bind(this)} initialFocusLocation={this.state.initialFocusLocationEtc} /> },
    ];
    
    // プレビューのサムネイル
    let preview_thumbnail = (preview.thumbnail != null) ? preview.thumbnail : preview.media_url;
    
    // プレビューのフォロワー表示
    let is_show_followers_count = (this.state.show_followers_count == true) ? 'followers-show' : 'followers-hide';
    
    return (
      <div className="report-create-edit-box update">
        <div className="button" onClick={this.showModal.bind(this)}><i className="material-icons">edit</i>レポート編集</div>
        
        <ContentsModal
          view      = {this.state.modal}
          width     = {width}
          height    = {'calc(100% - 110px)'}
          left      = {left}
          close_ev  = {this.closeModal.bind(this)}
          html      = {
            <div className="report-setting-modal">
              <h1>レポートの編集</h1>
              <h3>インフルエンサーのレポートを変更できます。カラムを選択することで投稿の詳細とインサイトデータが閲覧されます。</h3>
              
              <ContentsTab select={this.state.tab} tabs={tabs} mode="off-screen" font_size={14} change_ev={this.changeTab.bind(this)} direct_change={true} />
            </div>
          }
        />
        
        { (this.state.modal == true) &&
          <div className={'post-preview '+ is_reduction}>
            <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>{(this.state.is_reduction) ? '投稿詳細を表示する' : '投稿詳細を非表示にする'}</Tooltip>}>
              <div className="eduction-button" onClick={this.actionReduction.bind(this)}>
                <i className="material-icons">keyboard_double_arrow_right</i>
              </div>
            </OverlayTrigger>
            
            { (is_preview == true)
              ? <div className="post-preview-item">
                  <p className="name">{preview.insta_id} さんの投稿</p>
                  
                  <div className="thumbnail">
                    {(preview_thumbnail != null && preview_thumbnail.indexOf('.jpg') !== -1) ? <img src={preview_thumbnail} onError={(e)=>{preview_thumbnail}} /> : null }
                    {(preview_thumbnail != null && preview_thumbnail.indexOf('.png') !== -1) ? <img src={preview_thumbnail} onError={(e)=>{preview_thumbnail}} /> : null }
                    {(preview_thumbnail != null && Utils.isVideo(preview_thumbnail)) ? <video src={preview_thumbnail} /> : null }
                  </div>
                  
                  <div className="post-preview-box">
                    <a className="link" href={'https://www.instagram.com/p/'+ preview.shortcode} target="_blank">URL</a>
                    <a className="followers" onClick={this.setFollowersCount.bind(this)}>{(this.state.show_followers_count == true) ? 'フォロワー数 非表示' : 'フォロワー数 表示' }</a>
                  </div>
                  
                  {(this.state.show_followers_count == true) &&
                    <div className="followers-box">
                      <p>投稿時のフォロワー数：{Utils.viewInt(preview.post_followers_count)}</p>
                      <p>契約時のフォロワー数：{Utils.viewInt(preview.entry_followers_count)}</p>
                    </div>
                  }
                  
                  <div className={'insight '+ is_show_followers_count}>
                    <h6>インサイト</h6>
                    <div className="insight-images">
                      { (preview.insight.length == 0) && <p className="none">インサイトが未提出です</p> }
                      { preview.insight.map((d, key) => {
                        return (
                          <div key={key} className="image-box">
                            <h6>{(key + 1)}枚目</h6>
                            <h5>{Utils.setDate(d.update_date, 'YYYY/M/D HH:mm')}</h5>
                            <h4><i className="material-icons" onClick={this.deleteInishgt.bind(this, d.id)}>delete</i></h4>
                            <p><img src={d.file_url} /></p>
                          </div>
                        );
                      })}
                    </div>
                    
                    <InsightUpload contents_id={preview.contents_id} project_id={base.project.id} emphasis_columns={this.state.emphasis_columns} report_update_ev={this.updateReports.bind(this)} />
                  </div>
                </div>
              : <div className="not-select">ここに投稿が表示されます</div>
            }
          </div>
        }
      </div>
    );
  }
}
// -------------------------------------------------------

class ReportScoreSettingGrid extends React.Component {
  render() {
    let base = this.props.data;
    
    let parent_columns = [];
    let columns = [];
    
    if( this.props.mode == 'base' ){
      parent_columns = [
        { id: 'basic',         name: '基本データ',             colspan: 2 },
        { id: 'basic',         name: 'URL',                    colspan: 1 },
        { id: 'basic',         name: '投稿データ',             colspan: 2 },
        { id: 'score_basic',   name: '基本スコア',             colspan: 3 },
        { id: 'score_reach',   name: 'リーチスコア',           colspan: 4 },
        { id: 'score_feed',    name: 'インプレッションスコア', colspan: 4 },
        { id: 'score_reel',    name: 'リールスコア',           colspan: 5 },
        { id: 'result',        name: '結果',                   colspan: 3 },
      ];
      
      columns = [
        { id: 'shortcode',             name: '投稿ID',             parent: 'basic',        type: 'text',     width: 100 },
        { id: 'insta_id',              name: 'インスタID',         parent: 'basic',        type: 'text',     width: 150 },
        { id: 'post_url',              name: '投稿URL',            parent: 'basic',        type: 'text',     width: 250 },
        { id: 'post_date',             name: '投稿日',             parent: 'basic',        type: 'date',     width: 100 },
      ];
      Const.value.reportColumns.map((c) => { columns.push(c); });
      
      columns.push({ id: 'reach_per', name: 'リーチ率', parent: 'result', type: 'text', className: 'text-right', width: 100 });
      columns.push({ id: 'eng_per',   name: 'ENG率',    parent: 'result', type: 'text', className: 'text-right', width: 100 });
      columns.push({ id: 'saved_per', name: '保存率',   parent: 'result', type: 'text', className: 'text-right', width: 100 });
    }
    
    if( this.props.mode == 'etc' ){
      parent_columns = [
        { id: 'basic',         name: '基本データ',             colspan: 2 },
        { id: 'basic',         name: 'URL',                    colspan: 1 },
        { id: 'basic',         name: '投稿データ',             colspan: 2 },
        { id: 'score_story',   name: 'ストーリーズスコア',     colspan: 7 },
        { id: 'score_plays',   name: 'TIKTOKスコア',           colspan: 3 },
      ];
      
      columns = [
        { id: 'shortcode',          name: '投稿ID',              parent: 'basic',        type: 'text',     width: 100 },
        { id: 'insta_id',           name: 'インスタID',          parent: 'basic',        type: 'text',     width: 150 },
        { id: 'post_url',           name: '投稿URL',             parent: 'basic',        type: 'text',     width: 250 },
        { id: 'post_date',          name: '投稿日',              parent: 'basic',        type: 'date',     width: 100 },
        { id: 'followers',          name: 'フォロワー数',        parent: 'basic',        type: 'viewInt', product_types: ['STORY', 'TIKTOK'], className: 'text-right', width: 100 },
        { id: 'reach',              name: 'リーチ',              parent: 'score_story',  type: 'viewInt', product_types: ['STORY'],           className: 'text-right',   width: 100 },
        { id: 'impressions',        name: '閲覧数',              parent: 'score_story',  type: 'viewInt', product_types: ['STORY'],           className: 'text-right',   width: 100 },
        { id: 'likes',              name: 'いいね',              parent: 'score_story',  type: 'viewInt', product_types: ['STORY'],           className: 'text-right',   width: 100 },
        { id: 'reply',              name: '返信',                parent: 'score_story',  type: 'viewInt', product_types: ['STORY'],           className: 'text-right',   width: 100 },
        { id: 'share',              name: 'シェア数',            parent: 'score_story',  type: 'viewInt', product_types: ['STORY'],           className: 'text-right',   width: 100 },
        { id: 'link_click',         name: 'リンクのクリック',    parent: 'score_story',  type: 'viewInt', product_types: ['STORY'],           className: 'text-right',   width: 100 },
        { id: 'tap_count',          name: 'スタンプのタップ数',  parent: 'score_story',  type: 'viewInt', product_types: ['STORY'],           className: 'text-right',   width: 100 },
        //{ id: 'plays_time',         name: '再生時間',            parent: 'score_plays',  type: 'viewInt', product_types: ['REELS'],           className: 'text-right',   width: 100 },
        { id: 'plays_time',         name: '動画視聴数',            parent: 'score_plays',  type: 'viewInt', product_types: ['REELS'],           className: 'text-right',   width: 100 },
        { id: 'plays_time_avg_sec', name: '平均視聴時間（秒）',  parent: 'score_plays',  type: 'viewInt', product_types: ['REELS'],           className: 'text-right',   width: 100 },
        { id: 'plays_per',          name: 'フル視聴率（％）',    parent: 'score_plays',  type: 'viewPer', product_types: ['REELS'],           className: 'text-right',   width: 100 },
      ];
    }
    
    // 集計結果の選択
    let items = (this.props.update.length > 0) ? this.props.update : this.props.reports;
    items = items.map((d) => {
      let reach_per = ((parseInt(d.reach) / parseInt(d.followers)) * 100);
      if( isNaN(reach_per) == false && reach_per != 'Infinity' ) d.reach_per = reach_per.toFixed(2) +'%';
      
      let eng_per = (((parseInt(d.likes) + parseInt(d.comments)) / parseInt(d.followers)) * 100);
      if( isNaN(eng_per) == false && eng_per != 'Infinity' ) d.eng_per = eng_per.toFixed(2) +'%';
      
      let saved_per = ((parseInt(d.saved) / parseInt(d.followers)) * 100);
      if( isNaN(saved_per) == false && saved_per != 'Infinity' ) d.saved_per = saved_per.toFixed(2) +'%';
      
      return d;
    });
    
    // レポートが存在しない場合
    if( items.length == 0 ){
      return (
        <div className="none-report">レポートが未登録です</div>
      );
    }
    
    return (
      <div className="report-setting-modal-grid">
        <Grid
          items                = {items}
          parent_columns       = {parent_columns}
          columns              = {columns}
          disable_columns      = {['shortcode', 'insta_id', 'post_url', 'post_date', 'reach_per', 'eng_per', 'saved_per']}
          emphasis_columns     = {this.props.update_cell}
          auto_set_columns     = {['reach_per', 'eng_per', 'saved_per']}
          focus_ev             = {this.props.focus_ev.bind(this)}
          update_ev            = {this.props.update_ev.bind(this)}
          stickyLeftColumns    = {3}
          stickyTopRows        = {3}
          add_button           = {false}
          defaultRowCount      = {0}
          initialFocusLocation = {this.props.initialFocusLocation}
        />
        
        <div className="yes-no">
          <div className="button" onClick={this.props.save_ev.bind(this)}>保存</div>
          <div className="button no" onClick={this.props.close_ev.bind(this)}>キャンセル</div>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

class InsightUpload extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      event : {},
      complete_url : [],
      update_urls : [],
      insight_modal : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * イベント設定
   */
  setEvent(column, ev) {
    let event = this.state.event;
    event[column] = ev;
    this.setState({ event: event });
  }
  // -------------------------------------------------------
  
  /*
   * データ更新時反映
   */
  actionProgress() {
    let update_urls = this.state.update_urls;
    let complete_url = this.state.complete_url;
    
    let media = this.state.event.get_media.bind(this)();
    for( let i in media ){
      let d = media[i];
      if( d.is_complete == true ){
        update_urls.push({ contents_id: d.after_params.contents_id, url: d.url });
        complete_url.push(d.url);
      }
    }
    this.setState({ update_urls: update_urls, complete_url: complete_url });
    
    if( media[0].file_count == complete_url.length ){
      this.updateInsight.bind(this)(update_urls);
      this.setState({ update_urls: [] });
    }
  }
  // -------------------------------------------------------
  
  updateInsight(urls) {
    Utils.request.bind(this)('/api/project/workflow/update_insights', { project_id: this.props.project_id, urls: urls },
      function(res){
        this.props.report_update_ev.bind(this)(res.body.reports, res.body.reports_etc);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  toggleModal(flg) {
    this.setState({ insight_modal: flg });
  }
  // -------------------------------------------------------
  
  render() {
    let event = this.state.event;
    
    // 下書き編集リンク
    //let insight_upload_link = 'https://casting.moribus.jp/project/report-insight-upload/'+ project_id;
    let insight_upload_link = 'https://192.168.32.129:4000/project/report-insight-upload/'+ this.props.project_id +'/'+ this.props.contents_id;
    
    return (
      <div className="insight-upload">
        <div className="upload-form">
          <S3Upload setEvent={this.setEvent.bind(this)} actionProgress={this.actionProgress.bind(this)} />
          
          <p className="modal-button" onClick={this.toggleModal.bind(this, true)}>インサイトを追加</p>
          
          <ContentsModal
            view      = {this.state.insight_modal}
            width     = {200}
            height    = {200}
            close_ev  = {this.toggleModal.bind(this, false)}
            html      = {
              <div>
                <label>
                  <input type="file" name="example" size="30" multiple onChange={(e) => { event.file_upload.bind(this)(e, 'insight/', { contents_id: this.props.contents_id }) }} />
                  <span>アップロードする</span>
                </label>
                
                <h6 className="qr-h6">モバイル端末でアップロードする場合</h6>
                <div className="qr">
                  <QRCode size={100} style={{ height: "auto", maxWidth: "100%", width: "100%" }} value={insight_upload_link} viewBox={`0 0 256 256`} />
                </div>
              </div>
            }
          />
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ReportEdit;